// extracted by mini-css-extract-plugin
export default {"bx":"reciept_bx__gXTDB","row":"reciept_row__h6XV9","footer":"reciept_footer__CGEfW","uploadBx":"reciept_uploadBx__cMMJC","uploadContent":"reciept_uploadContent__EbCkV"};